import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import GeneralNavigationIntercomHelpLink from 'lumen/components/general/navigation/intercom-help-link';
import HotelAndMarketRevenueInsightDataOriginBadge from 'lumen/components/hotel-and-market/revenue-insight/data-origin-badge';
import {
  RI_SECTIONS,
  type RiSection,
} from 'lumen/utils/constants/ri-constant-values';

type IntercomLinkArgs =
  | {
      infoIntercomLinkLink: string;
      infoIntercomLinkTooltipContent: string;
      shouldShowInfoIntercomLink: true;
    }
  | {
      shouldShowInfoIntercomLink?: false;
    };

type InfoIconTooltipArgs =
  | {
      infoIconTooltipContent: string;
      shouldShowInfoIconTooltip: true;
    }
  | {
      shouldShowInfoIconTooltip?: false;
    };

interface HotelAndMarketRevenueInsightSectionTitleSignature {
  Args: IntercomLinkArgs &
    InfoIconTooltipArgs & {
      section: RiSection;
      titleContent: string;
    };
  Blocks: {
    default: [];
  };
}

export default class HotelAndMarketRevenueInsightSectionTitle extends Component<HotelAndMarketRevenueInsightSectionTitleSignature> {
  @service declare riSelections: Services['ri-selections'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get vsText() {
    const ignoreNetComparison = this.args.section === RI_SECTIONS.PICKUP;
    return this.riSelections.getVsText(ignoreNetComparison);
  }

  <template>
    <div class="flex items-center justify-between">
      <div class="header-title text-neutral-emphasis mr-200 flex items-center">
        <h2>{{@titleContent}}</h2>

        {{#if @shouldShowInfoIntercomLink}}
          <GeneralNavigationIntercomHelpLink
            @articleLink={{@infoIntercomLinkLink}}
            @iconName="circle-question-mark"
            @tooltipText={{@infoIntercomLinkTooltipContent}}
            @type="icon"
          />
        {{/if}}

        {{#if @shouldShowInfoIconTooltip}}
          <GeneralIconWithTooltip
            @side="top"
            @tooltipContent={{@infoIconTooltipContent}}
          />
        {{/if}}

        <span class="text-300--regular">{{this.vsText}}</span>

        {{#if this.riSelections.hasSummaryOverwrite}}
          <HotelAndMarketRevenueInsightDataOriginBadge @section={{@section}} />
        {{/if}}
      </div>

      {{yield}}
    </div>
  </template>
}
